<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px" label-width="80px">
      <el-form-item label="名称">
        <el-input v-model="queryParams.name" class="!w-200px" clearable @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">搜索</el-button>
        <el-button @click="getList">刷新</el-button>
      </el-form-item>
    </el-form>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="从供应商可选品库选品挂本店，生成下架商品后请到商品管理上架。"
    />
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="编号" prop="id" width="80" />
      <el-table-column label="供应商" prop="supplierName" min-width="120" />
      <el-table-column label="商品名称" prop="name" min-width="160" />
      <el-table-column label="封面" width="90">
        <template #default="{ row }">
          <el-image v-if="row.picUrl" :src="row.picUrl" class="!w-48px !h-48px" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template #default="{ row }">
          <el-button link type="primary" @click="openPick(row)">选品挂店</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="pickVisible" title="选品挂本店" width="480px">
    <el-form label-width="100px">
      <el-form-item label="商品">{{ current?.name }}</el-form-item>
      <el-form-item v-if="needExpress" label="运费模板" required>
        <el-select v-model="pickTemplateId" filterable class="!w-full" placeholder="请选择本店运费模板">
          <el-option v-for="t in templates" :key="t.id" :label="t.name" :value="t.id!" />
        </el-select>
      </el-form-item>
      <div class="text-12px text-gray-500">挂店后生成下架商品，请到商品管理再上架。</div>
    </el-form>
    <template #footer>
      <el-button @click="pickVisible = false">取消</el-button>
      <el-button type="primary" :loading="loadingPick" @click="doPick">确定</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { getMerchantPoolDraftPage, pickMerchantPoolDraft } from '@/api/merchant/product/pool'
import * as MerchantExpressTemplateApi from '@/api/merchant/delivery/expressTemplate'
import { DeliveryTypeEnum } from '@/utils/constants'

defineOptions({ name: 'MerchantPoolPick' })

const loading = ref(false)
const loadingPick = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const queryParams = reactive({ pageNo: 1, pageSize: 10, name: undefined as string | undefined })
const pickVisible = ref(false)
const current = ref<any>()
const pickTemplateId = ref<number>()
const templates = ref<MerchantExpressTemplateApi.DeliveryExpressTemplateVO[]>([])

const needExpress = computed(() =>
  (current.value?.deliveryTypes || []).includes(DeliveryTypeEnum.EXPRESS.type)
)

const getList = async () => {
  loading.value = true
  try {
    const data = await getMerchantPoolDraftPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const openPick = async (row: any) => {
  current.value = row
  pickTemplateId.value = undefined
  templates.value = (await MerchantExpressTemplateApi.getSimpleTemplateList()) || []
  pickVisible.value = true
}

const doPick = async () => {
  if (!current.value?.id) return
  if (needExpress.value && !pickTemplateId.value) {
    ElMessage.warning('请选择运费模板')
    return
  }
  loadingPick.value = true
  try {
    await pickMerchantPoolDraft({
      id: current.value.id,
      deliveryTemplateId: pickTemplateId.value
    })
    ElMessage.success('已挂店生成下架商品，请到商品管理上架')
    pickVisible.value = false
  } finally {
    loadingPick.value = false
  }
}

onMounted(getList)
</script>
